import axios from 'axios';
import { useNavigate } from 'react-router-dom';

// Create an axios instance
const axiosInstance = axios.create({
  baseURL: 'https://todaylocal.in/api/', // Your API URL here
});

// Request interceptor to add session token to request headers
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('sessiontoken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // If 401 status, redirect to login page
      localStorage.removeItem('sessiontoken');
      window.location.href = '/reporter/login';  // Redirect to login page
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
